<template>
  <div class="auto-refill-failed">

  </div>
</template>

<script>
export default {
  name: 'AutoRefillFailed'
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/auto-refill/auto-refill-state/Failed.vue